import request from '@/utils/http';
import { SRM } from '../constant/constant.js'

// 根据条件查询基本类型配置列表
export const getSupplierInfo = (params) => {
    return request({
        url: `${SRM}/manage/showSupplierInfoDetail`,
        method: 'get',
        params
    });
};

// 清算操作
export const clearSupplier = (params) => {
    return request({
        url: `${SRM}/manage/clearingSupplierCost`,
        method: 'post',
        data: params
    });
};

// MIP提交
export const submitSupplier = (params) => {
    return request({
        url: `${SRM}/manage/submitMip`,
        method: 'post',
        data: params
    });
};

// 审核人-MIP提交
export const searchMip = (params) => {
    return request({
        url: `${SRM}/manage/searchMip`,
        method: 'post',
        data: params
    });
};

// 特批操作
export const operateSupplierSpecially = (params) => {
    return request({
        url: `${SRM}/manage/specialApprovalOprate`,
        method: 'post',
        data: params
    });
};

// 保存
export const addSupplier = (params) => {
    return request({
        url: `${SRM}/manage/saveSupplierDetail`,
        method: 'post',
        data: params
    });
};

// 更新
export const editSupplier = (params) => {
    return request({
        url: `${SRM}/manage/editSupplierTypeCommit`,
        method: 'put',
        data: params
    });
};

// 重新启用
export const reinsertSupplier = (params) => {
    return request({
        url: `${SRM}/manage/reinsertSupplier`,
        method: 'post',
        data: params
    });
};

// 整改完成
export const abarbeitungSupplier = (params) => {
    return request({
        url: `${SRM}/manage/abarbeitungSupplier`,
        method: 'post',
        data: params
    });
};

export const checkMipSubmit = (params) => {
    return request({
        url: `${SRM}/manage/checkMipSubmit`,
        method: 'get',
        params: params
    });
};

export const deleteSupplier = (params) => {
    return request({
        url: `${SRM}/supplierInfo/delete`,
        method: 'post',
        data: params
    });
};

// 同步供应商集团信息查询
export const syncGsrmSupplierGroup = (params) => {
    return request({
        url: `${SRM}/syncGsrmSupplierGroup`,
        method: 'post',
        data: params
    });
};

// 同步供应商集团信息导入
export const introductionGroupSupplier = (params) => {
    return request({
        url: `${SRM}/introductionGroupSupplier`,
        method: 'post',
        data: params
    });
};

// 生成客户
export const genCrmCustomerCode = data => {
    return request({
        url: `${SRM}/genCrmCustomerCode`,
        method: 'post',
        data,
    });
};

// 获取供应商对应的业务类型
export const getBusinessTypeList = (params) => {
    return request({
        url: `${SRM}/businessTypeList`,
        method: 'post',
        data: params
    });
};

// MIP提交、特批申请、变更校验
export const checkMipSubmitByScBt = data => {
    return request({
        url: `${SRM}/checkMipSubmitBySupplierCodeAndBusinessType`,
        method: 'get',
        params: data
    })
}

// 流程信息返回供应商信息
export const getSupByAuditId = data => {
    return request({
        url: `${SRM}/supplierBusinessType/selectByAuditId`,
        method: 'get',
        params: data,
    });
};

// 退出业务类型信息
export const getQuitBlackByAuditId = data => {
    return request({
        url: `${SRM}/supplierQuitBlack/detail`,
        method: 'post',
        data,
    });
};

// 供应商变更审批信息
export const getSupplierChangeInfo = data => {
    return request({
        url: `${SRM}/supplierChangeApply/getSupplierChangeInfo/${data}`,
        method: 'get',
    });
};

// 根据供应商编码获取【供应商资质预警、司机证件预警、车辆证件预警，转包预警】标签接口
export const getSupplierWarningTags = (supplierCode, businessType) => {
    return request({
        url: `${SRM}/supplierWarningTags/${supplierCode}/${businessType}`,
        method: 'get',
    });
};

// 根据流程ID获取【供应商资质预警、司机证件预警、车辆证件预警，转包预警】标签接口
export const getSupplierWarningTagsByIFlow = (fdId) => {
    return request({
        url: `/api-srm-web/supplier/supplierWarningTags/iFlow/${fdId}`,
        method: 'get',
    });
};

